import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

const Home = () => {
  const { pathname } = useLocation()

  return pathname === '/' ? (
    <h1>Hello web-app-filters!</h1>
  ) : (
    <Outlet />
  )
}

export default Home
